<template>
    <div class="templete">
        <div class="search_box clearfix StockSearch">
            <el-input class="search_input search_inputBox" v-model="params.bale_no" @keyup.enter.native="getList(true)" placeholder="捆包号" size="mini"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.breed_id" multiple collapse-tags placeholder="品名" @visible-change="getSelectWarehouseList('breed_id')">
                    <el-option v-for="list in selectMapC.breed_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.brand_id" multiple collapse-tags placeholder="品牌" @visible-change="getSelectWarehouseList('brand_id')">
                    <el-option v-for="list in selectMapC.brand_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.grade_id" multiple collapse-tags placeholder="等级" @visible-change="getSelectWarehouseList('grade_id')">
                    <el-option v-for="list in selectMapC.grade_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.thickness" multiple collapse-tags filterable placeholder="厚度" @visible-change="getSelectWarehouseList('original_thickness')">
                    <el-option v-for="(list,index) in selectMapC.original_thickness" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.length" multiple collapse-tags placeholder="长度" @visible-change="getSelectWarehouseList('original_length')">
                    <el-option v-for="(list,index) in selectMapC.original_length" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.status" multiple collapse-tags placeholder="销售状态">
                    <el-option v-for="list in statusList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox"   v-model="params.warehouse_id" multiple collapse-tags placeholder="仓库" @visible-change="getSelectWarehouseList('warehouse_id')">
                    <el-option v-for="list in selectMapC.warehouse_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.supplier_id" multiple collapse-tags placeholder="供应商" filterable @visible-change="getSelectWarehouseList('supplier_id')">
                    <el-option v-for="list in selectMapC.supplier_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-if="isShowMore" @keyup.enter.native="getList(true)" v-model="params.contract_no" placeholder="合同号" size="mini"></el-input>
                <!-- <div class="search_time search_inputBox">
                    <el-date-picker v-model="inbound_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="入库时间"></el-date-picker>
                </div> -->
                <el-select class="search_select search_inputBox" v-model="params.check_status" v-if="isShowMore" multiple collapse-tags  placeholder="检尺状态">
                    <el-option :value="999" label="全部检尺状态"></el-option>
                    <el-option :value="1" label="已检尺"></el-option>
                    <el-option :value="0" label="未检尺"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.original_bale" placeholder="供单号" size="mini"></el-input>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.opening_company_id" placeholder="货权单位" @visible-change="getSelectWarehouseList('opening_company_id')">
                    <el-option v-for="list in selectMapC.opening_company_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <div class="search_time search_inputBox" v-if="isShowMore">
                    <el-input v-model="params.price_min" @keyup.enter.native="getList(true)" placeholder="价格区间" size="mini"></el-input>
                    ~
                    <el-input v-model="params.price_max" @keyup.enter.native="getList(true)" placeholder="价格区间" size="mini"></el-input>
                </div>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.bill_lading_no" placeholder="提单号" size="mini"></el-input>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.container_no" placeholder="货柜号" size="mini"></el-input>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.storage_age" placeholder="库龄" size="mini"></el-input>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.storage_location" placeholder="库位" size="mini"></el-input>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.attribute_id" multiple collapse-tags placeholder="属性" @visible-change="getSelectWarehouseList('attribute_id')">
                    <el-option v-for="list in selectMapC.attribute_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.color_id" multiple collapse-tags placeholder="选色" @visible-change="getSelectWarehouseList('color_id')">
                    <el-option v-for="list in selectMapC.color_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.bale_status" v-if="isShowMore" multiple collapse-tags  placeholder="资源状态">
                    <el-option :value="999" label="全部资源状态"></el-option>
                    <el-option :value="0" label="在途"></el-option>
                    <el-option :value="1" label="现货"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.remark" placeholder="备注" size="mini"></el-input>
            <!-- <el-select class="search_select search_inputBox" v-model="params.port_id" multiple collapse-tags placeholder="目的港">
                <el-option v-for="list in portList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select> -->
            <!-- <el-input class="search_input search_inputBox" v-model="params.container_no" placeholder="货柜号" size="mini"></el-input> -->
            <div class="searchBtnList clearfix">
                <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                <div class="reset fcolor" style="margin: 0 20px;">
                    <el-checkbox v-model="is_like">精确查找</el-checkbox>
                </div>
            </div>
            <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
            </div>
        </div>
        <div class="tableBox selectStockTable">
            <tabletem :isSetCol="true" scene="inventory.select.stock" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @sortTable="sortTable" @getRow="getRow" @rowClick="rowClick"></tabletem>
        </div>
        <div class="pageBox">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <div class="btnList clearfix">
            <div class="totalBox">
                <div class="total">选中件数：{{totalNumber}}件</div>
                <div class="total">选中方数：{{totalCube}}</div>
            </div>
            <div class="btnBox">
                <el-button  class="funcPublicBtn" @click="cancel">取消</el-button>
                <el-button  class="funcPublicBtn" @click="selectData">选中</el-button>
                <el-button  class="funcPublicBtn funcPublicBtnChecked" @click="selectAndOut">选中并退出</el-button>
            </div>
        </div>
        <!-- 宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="false" :list="widthList" @cancelWidth="()=>{this.dialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 宽度列表END -->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="inventory.select.stock" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
    </div>
</template>
<script>
    import tabletem from './table.vue'
    import pagination from './pagination.vue'
    export default {
        data(){
            return{
                tableLoading:false,
                isShowMore:false,
                dialogVisibleWidth:false,
                params:{
                    supplier_id:"",
                    breed_id:"",
                    thickness:"",
                    length:"",
                    grade_id:"",
                    bale_no:"",
                    warehouse_id:"",
                    price_min:"",
                    price_max:"",
                    contract_no:"",
                    bill_lading_no:"",
                    container_no:"",
                    storage_age:"",
                    storage_location:"",
                    remark:"",
                    status:"",
                    attribute_id:"",
                    color_id:"",
                    opening_company_id:"",
                    original_bale:"",
                    check_status:"",
                    bale_status:"",
                    per_page:50,
                    page:1
                },
                last_page:1,
                total:0,
                totalNumber:0,
                totalCube:0,
                selectRow:[],
                selectMapC:{
                    supplier_id:[],
                    breed_id:[],
                    brand_id:[],
                    port_id:[],
                    grade_id:[],
                    warehouse_id:[],
                    original_length:[],
                    original_thickness:[],
                    attribute_id:[],
                    color_id:[],
                    opening_company_id:[]
                },
                statusList:[],
                widthList:[],
                list:[],
                filterDialogVisible:false,
                filter:"",
                fields:"",
                tableCol:[	
                    {colName:"资源状态",colKey:"stock_status_text",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"检尺状态",colKey:"check_status_text",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"捆包号",colKey:"bale_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"供单号",colKey:"original_bale",colWidth:65,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"品名",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"销售品名",colKey:"sales_breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"产品图片",colKey:"thumbnail",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isStockImg:true},
                    {colName:"等级",colKey:"grade",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"属性",colKey:"attribute",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"选色",colKey:"color",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"编码",colKey:"code",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"厚度",colKey:"original_thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"长度",colKey:"original_length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"片数",colKey:"pieces",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"层数",colKey:"sales_layer_number",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"总宽度",colKey:"sales_width_total",colWidth:80,isSetWidth:true,isCanClick:true,isShow:true,isColor:true,isHideShowClickImg:true,isHideCanClickColor:true},
                    {colName:"销售立方",colKey:"sales_cube",colWidth:95,isSetWidth:true,isCanClick:false,isShow:true,isSort:true,isSort:true},
                    {colName:"码单立方",colKey:"original_cube",colWidth:95,isSetWidth:true,isCanClick:false,isShow:true,isSort:true,isSort:true},
                    {colName:"检尺立方",colKey:"check_cube",colWidth:95,isSetWidth:true,isCanClick:false,isShow:true,isSort:true,isSort:true},
                    {colName:"挂牌价",colKey:"listed_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"供应商",colKey:"supplier",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"仓库",colKey:"warehouse",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"货权单位",colKey:"opening_company",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"销售状态",colKey:"status_text",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"锁定人",colKey:"locker_name",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"锁定等级",colKey:"lock_level",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,islockLevel:true},
                    {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"合同号",colKey:"contract_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"提单号",colKey:"bill_lading_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"货柜号",colKey:"container_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"外商单号",colKey:"ex_order_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"目的港",colKey:"purpose_port",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"预计到港日期",colKey:"expected_arrival_time",colWidth:95,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    {colName:"入库时间",colKey:"inbound_time",colWidth:95,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    {colName:"库龄",colKey:"storage_age",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"库位",colKey:"storage_location",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"挂牌金额",colKey:"listed_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:true}
                ],
                is_like:false,
            }
        },
        created(){
            this.postFunc("/erp/inventory.select.status",{},res=>{
                this.statusList=res.data.data;
            },error=>{
                this.tip(error.data.message,"warning")
            })
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList()
        },
        methods:{
            filterConfirm(){
                this.getList()
            },
            getSelectWarehouseList(target){
                // spots
                this.$getSelectWarehouseList(target,this.params,"","sales").then(res=>{
                    this.selectMapC[res.data.data.target]=res.data.data.result;
                })
            },
            cancel(){
                this.$emit("cancel")
            },
            selectData(){
                this.$emit("selectData",this.selectRow)
            },
            selectAndOut(){
                this.$emit("selectAndOut",this.selectRow)
            },
            reset(){
                this.params=this.resetSearch(this.params)
                this.getList();
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.is_like = this.is_like;
                this.tableLoading = true;
                this.$postColumnList("/erp/inventory.select.stock",this.params,res=>{
                    this.last_page=parseInt(res.data.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.data.total);
                    this.list=res.data.data.data.data;
                    this.list.forEach((item,ind)=>{
                        if(item.inbound_time){
                            this.list[ind].inbound_time = this.formatTime(this.list[ind].inbound_time+"000")
                        }else{
                            this.list[ind].inbound_time = "";
                        }
                        if(item.expected_arrival_time){
                            this.list[ind].expected_arrival_time = this.formatTime(this.list[ind].expected_arrival_time+"000")
                        }else{
                            this.list[ind].expected_arrival_time = "";
                        }
                        item.baseColor = "";
                        //this.list[ind].original_width_total = parseInt( this.list[ind].original_width_total);
                        if(item.status==1&&item.lock_status==0){
                            item.baseColor="#222";
                        }else if(item.status==2){
                            item.baseColor="#155BD4";
                        }else if(item.status==3){
                            item.baseColor="#B400FF";
                        }else if(item.status==4){
                            item.baseColor="#007B04";
                        }else if(item.status==1&&item.lock_status==1){
                            item.baseColor="#FF0000";
                        }
                        // this.list[index].thickness = this.keepLimit(item.thickness)
                        // this.list[index].length = this.keepLimit(item.length)
                        if((((item.status==1||item.status==0)&&item.lock_status==0)&&item.check_rule == 0)&&item.sales_select==1){
                            item.isCanSelection=false;
                        }else{
                            item.isCanSelection=true;
                        }
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        // if(item.colKey=="status_text"||item.colKey=="stock_status_text"){
                        //     if(this.fields.indexOf(",status,")!=-1){
                        //         item.isShow=true;
                        //     }
                        // }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            rowClick(obj){
                if(obj.name=="sales_width_total"){
                    this.list.forEach(item=>{
                        if(item.id==obj.id){
                            this.widthList = item.sales_width;
                            this.dialogVisibleWidth = true;
                        }
                    })
                }
            },
            //表格排序
            sortTable(sort){
                this.params.field = sort.order ? sort.prop:'';
                this.params.sort = sort.order == "ascending"?"asc":sort.order == "descending"?"desc":"";
                this.getList();
            },
            getRow(row){
                this.selectRow=row;
                this.totalNumber=this.selectRow.length;
                this.totalCube=0;
                this.selectRow.forEach(item=>{
                    this.totalCube+=Number(item.sales_cube);
                })
                this.totalCube=this.keepLimit(this.totalCube)
            },
            resetSelect(){
                this.reset()
            }
        },
        components:{
            tabletem,
            pagination
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            }
        }
    }
</script>
<style scoped>
    .pageAssembly .pageSize{margin-top:3px;}
    .totalBox{float: left;}
    .totalBox .total{float: left;font-size: 12px;line-height: 33px;margin-right:15px;}
    .btnBox{float: right;}
</style>